import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table, Input,
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import SelectMulti from '../../../../helpers/ui/SelectMulti'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'

class CreateView extends Component {

    indexBloc = new IndexBloc()
    createBloc = new CreateBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            type: null,
            isDraft: 0,
            tableData: [],
            employeeOption: [],
            positionOption: [],
            workUnitOption: [],
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 10000,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            },
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            workUnitFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'work_unit_id',
                    order: 'asc' 
                }
            },
            positionLabel: "",
            failedMsg: "Data Gagal Disimpan" 
        }
    }
    
    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    addTableData = () => {
        const { tableData } = this.state
        let data = {
            id: this.makeid(6),
        }

        this.setState({ tableData: [ ...tableData, data ] })
    }

    removeTableData = (id) => {
        const { tableData } = this.state
        let newArr = tableData.filter(val => val.id != id)

        this.setState({ tableData: newArr })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'additional_task_document_uuid')
        await this.createBloc.fetchCreate(dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                isDraft: this.state.isDraft, 
                ...values
            },
            confirm: true
        })

        console.log(values)
    }

    checkplt = async () =>{
        const dataForm = generateFormData(this.state.dataForm, 'additional_task_document_uuid')
        await this.createBloc.fetchCheck(dataForm)
    } 

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.submitData()
                this.checkplt()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadEmployee = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        this.setState({ loadingEmployee: true })
        await this.indexBloc.fetchListPegawai(query)
    }

    loadPosition = async (type) => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1,
            type: type + 2
        }
        this.setState({ loadingPosition: true })
        await this.indexBloc.fetchListJabatan(query)
    }

    loadPositionPltPlh = async (uuid) => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1,
            type: 1,
            // employee_uuid: uuid
        }
        this.setState({ loadingPosition: true })
        await this.indexBloc.fetchListJabatan(query)
    }

    loadWorkUnit = async () => {
        let offset = (this.state.workUnitFilter.page_number-1)*this.state.workUnitFilter.page_size
        const query = {
            search: this.state.workUnitFilter.filter_value,
            limit: this.state.workUnitFilter.page_size,
            offset: offset,
            order: this.state.workUnitFilter.sort_order.column,
            sort: this.state.workUnitFilter.sort_order.order,
            status: 1,
        }
        this.setState({ loadingWorkUnit: true })
        await this.indexBloc.fetchListUnitKerja(query)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadEmployee()
        this.loadWorkUnit()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.listPegawaiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response.result, loadingEmployee: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.indexBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.listUnitKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ workUnitOption: result.data.response.result, loadingWorkUnit: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        this.createBloc.checkChannel.subscribe((result) => {
            console.log(result)
            console.log('ini result cek')
            // if(! result?.data?.status){
            //     this.submitData()
            // }else{
            //     this.setState({
            //         loading: false,
            //         failed: true,
            //         failedMsg: result.data.messege
            //     });
            // }

            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result)

                    if(! result?.data?.status){
                        this.submitData()
                    }else{
                        this.setState({
                            loading: false,
                            failed: true,
                            failedMsg: result.data.messege
                        });
                    }

                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        failedMsg: "Terjadi Kesalahan"
                    });
                    break
                default:
                    break
            }
        })


    }

    componentWillUnmount() {
        this.indexBloc.listPegawaiChannel?.unsubscribe()
        this.indexBloc.listJabatanChannel?.unsubscribe()
        this.indexBloc.listUnitKerjaChannel?.unsubscribe()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.type != this.state.type) {
            this.setState({ positionOption: [] })
            if (this.state.type <= 3) {
                this.loadPosition(this.state.type)
            }
        }
    }

    render() {
        const { tableData, type } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/petajabatan.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>    
                            <CardTitle>
                                {type <= 3 && 'Form Jabatan Pengelola Anggaran'}
                                {type > 3 && 'Form Jabatan Tugas Tambahan'}
                            </CardTitle>
                            <CardSubtitle className="mb-3" style={{ padding: 3 }}>
                            </CardSubtitle>
                            <hr/>
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Nomor SK <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <AvField
                                            name="additional_task_decree_number"
                                            placeholder="Nomor SK"
                                            errorMessage="Masukkan Nomor SK"
                                            type="text"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Tanggal SK <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <AvField
                                            name="additional_task_decree_date"
                                            placeholder="Tanggal SK"
                                            errorMessage="Masukkan Tanggal SK"
                                            type="date"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        TMT SK <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <AvField
                                            name="additional_task_tmt_date"
                                            placeholder="TMT SK"
                                            errorMessage="Masukkan TMT SK"
                                            type="date"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Upload SK <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <FileInput
                                            name="additional_task_document_uuid"
                                            placeholder="Upload SK"
                                            className="form-control"
                                            col="6"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Jenis Jabatan <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <Select
                                            name="additional_task_type"
                                            placeholder="Jenis Jabatan"
                                            errorMessage="Pilih Jenis Jabatan"
                                            options={[
                                                { value: 1, label: 'Pengelola Anggaran' },
                                                { value: 2, label: 'Pembantu Pengelola Anggaran' },
                                                { value: 3, label: 'POKJA' }, 
                                                { value: 4, label: 'PLT' }, 
                                                { value: 5, label: 'PLH' }
                                            ]}
                                            defaultValue={this.state.type}
                                            onChange={opt => this.setState({ type: opt.value })}
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>
                                <hr />

                                {/* <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Tanggal Mulai Berlaku <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <AvField
                                            name="additional_task_detail_start_date"
                                            placeholder="Tanggal Mulai Berlaku"
                                            errorMessage="Masukkan Tanggal Mulai Berlaku"
                                            type="date"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Tanggal Selesai Berlaku <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="3">
                                        <AvField
                                            name="additional_task_detail_end_date"
                                            placeholder="Tanggal Selesai Berlaku"
                                            errorMessage="Masukkan Tanggal Selesai Berlaku"
                                            type="date"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <hr/> */}
                                <Row>
                                    <Col md="12">
                                        <div className="float-end">
                                            <Button color="primary" onClick={() => this.addTableData()}>Tambah <i className="uil uil-plus"></i> </Button>
                                        </div>    
                                    </Col>
                                    <Col md="12">
                                        <hr/>
                                        <div className="table-responsive">
                                            <Table className="table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th width="25px">No</th>
                                                        <th className="text-center">NIP - Nama<br />Jabatan</th>
                                                        {/* <th className="text-center"></th> */}
                                                        { (this.state.type == 1 || this.state.type == 2 || this.state.type == null) &&
                                                            <>
                                                                <th className="text-center" width="35%">Jabatan Pengelola Anggaran<br />Satuan Kerja/Unit</th>
                                                            </>
                                                        }
                                                        { this.state.type == 3 &&
                                                            <Fragment>
                                                                <th className="text-center" width="35%">Kelompok Kerja<br />Jabatan Kelompok Kerja</th>
                                                            </Fragment>
                                                        }
                                                        { (this.state.type == 4 || this.state.type == 5) &&
                                                            <Fragment>
                                                                <th className="text-center" width="35%">Jabatan {this.state.type == 4 ? 'PLT' : 'PLH'}<br />Satuan Kerja/Unit</th>
                                                            </Fragment>
                                                        }
                                                        <th width="15%" className="text-center">Tanggal Mulai<br />Tanggal Selesai</th>
                                                        <th className="text-center">Aksi</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { tableData?.map((val, i) => {
                                                        return (
                                                            <tr key={val.id}>
                                                                <td>{i + 1}</td>
                                                                <td>
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <Select 
                                                                                name={`additional_task_detail_employee_uuid[${i}]`}
                                                                                options={this.state.employeeOption}
                                                                                optionLabel={opt => `${opt.employee_nip} - ${opt.employee_full_name}`}
                                                                                optionValue="employee_uuid"
                                                                                onChange={opt => {
                                                                                    this.setState({ [`selected${val.id}`]: opt })
                                                                                    if (this.state.type > 3) {
                                                                                        this.loadPositionPltPlh(opt.employee_uuid)
                                                                                    }
                                                                                }}
                                                                                isLoading={this.state.loadingEmployee}
                                                                                validate={{ required: { value: true } }}
                                                                            />
                                                                        </Col>
                                                                        {/* <Col md={6}>
                                                                            <Input
                                                                                value={this.state['selected'+val.id]?.employee_name}
                                                                                readOnly={true}
                                                                            />
                                                                        </Col> */}
                                                                        <Col md={12}>
                                                                            <Input 
                                                                                className="form-control mt-2"
                                                                                placeholder="Jabatan"
                                                                                value={this.state['selected'+val.id]?.employee_current_position_name}
                                                                                readOnly={true}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </td>
                                                                { (this.state.type == 1 || this.state.type == 2 || this.state.type == null) &&
                                                                    <>
                                                                        <td>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <Select 
                                                                                        name={`additional_task_detail_position_uuid[${i}]`}
                                                                                        options={this.state.positionOption}
                                                                                        optionLabel="position_name"
                                                                                        optionValue="position_uuid"
                                                                                        isLoading={this.state.loadingPosition}
                                                                                        validate={{ required: { value: true } }}
                                                                                    />
                                                                                </Col>
                                                                                <Col md={12} className="mt-2">
                                                                                    <Select 
                                                                                        name={`additional_task_detail_work_unit_uuid[${i}]`}
                                                                                        options={this.state.workUnitOption}
                                                                                        optionLabel="work_unit_name"
                                                                                        optionValue="work_unit_uuid"
                                                                                        isLoading={this.state.loadingWorkUnit}
                                                                                        validate={{ required: { value: true } }}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                        </td>
                                                                    </>
                                                                }
                                                                { this.state.type == 3 &&
                                                                    <Fragment>
                                                                        <td>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <Select 
                                                                                        name={`additional_task_detail_workgroup[${i}]`}
                                                                                        options={[
                                                                                            { value: 1, label: 'I' },
                                                                                            { value: 2, label: 'II' },
                                                                                            { value: 3, label: 'III' },
                                                                                            { value: 4, label: 'IV' },
                                                                                            { value: 5, label: 'V' },
                                                                                        ]}
                                                                                        isClearable={true}
                                                                                        defaultValue={this.state['workgroup'+val.id]}
                                                                                        onChange={opt => this.setState({ ['workgroup'+val.id]: opt?.value })}
                                                                                    />
                                                                                </Col>
                                                                                <Col md={12} className="mt-2">
                                                                                    <Select 
                                                                                        name={`additional_task_detail_position_uuid[${i}]`}
                                                                                        options={
                                                                                            this.state['workgroup'+val.id] != undefined ?
                                                                                                this.state.positionOption
                                                                                                :
                                                                                                this.state.positionOption.filter(opt => opt.position_name != 'Pejabat Pengadaan Langsung' && opt.position_name != 'Anggota')
                                                                                        }
                                                                                        optionLabel="position_name"
                                                                                        optionValue="position_uuid"
                                                                                        isLoading={this.state.loadingPosition}
                                                                                        validate={{ required: { value: true } }}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                        </td>
                                                                    </Fragment>
                                                                }
                                                                { (this.state.type == 4 || this.state.type == 5) &&
                                                                    <Fragment>
                                                                        <td>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <Select 
                                                                                        name={`additional_task_detail_position_uuid[${i}]`}
                                                                                        options={this.state.positionOption}
                                                                                        optionLabel="position_name"
                                                                                        optionValue="position_uuid"
                                                                                        onChange={opt => this.setState({ ['selectedPos'+val.id]: opt }) }
                                                                                        isLoading={this.state.loadingPosition}
                                                                                        validate={{ required: { value: true } }}
                                                                                    />
                                                                                </Col>
                                                                                <Col md={12}>
                                                                                    <Input
                                                                                        value={this.state['selectedPos'+val.id]?.work_unit_name}
                                                                                        readOnly={true}
                                                                                        className="form-control mt-2"
                                                                                    />
                                                                                    <AvField
                                                                                        name={`additional_task_detail_work_unit_uuid[${i}]`}
                                                                                        type="hidden"
                                                                                        value={this.state['selectedPos'+val.id]?.position_work_unit_uuid}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                        </td>
                                                                    </Fragment>
                                                                }
                                                                <td>
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <AvField
                                                                                name={`additional_task_detail_start_date[${i}]`}
                                                                                placeholder="Tanggal Mulai Berlaku"
                                                                                errorMessage="Masukkan Tanggal Mulai Berlaku"
                                                                                type="date"
                                                                                className="form-control"
                                                                                onChange={(e) => this.setState({ ['startDate'+val.id]: e.target.value })}
                                                                                max={this.state['endDate'+val.id] || ""}
                                                                                validate={{ 
                                                                                    required: { value: true },
                                                                                    dateValidation: (value, context) => {
                                                                                        const endDate = context[`additional_task_detail_end_date[${i}]`];
                                                                                        if (!value || !endDate) return true;
                                                                                        if (new Date(value) > new Date(endDate)) {
                                                                                            return "Tanggal mulai tidak boleh lebih besar dari tanggal selesai";
                                                                                        }
                                                                                        return true;
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col md={12}>
                                                                            <AvField
                                                                                name={`additional_task_detail_end_date[${i}]`}
                                                                                placeholder="Tanggal Selesai Berlaku"
                                                                                errorMessage="Masukkan Tanggal Selesai Berlaku"
                                                                                type="date"
                                                                                className="form-control mt-2"
                                                                                onChange={(e) => this.setState({ ['endDate'+val.id]: e.target.value })}
                                                                                min={this.state['startDate'+val.id] || ""}
                                                                                validate={{
                                                                                    dateValidation: (value, context) => {
                                                                                        const startDate = context[`additional_task_detail_start_date[${i}]`];
                                                                                        if (!value || !startDate) return true;
                                                                                        if (new Date(value) < new Date(startDate)) {
                                                                                            return "Tanggal selesai tidak boleh lebih kecil dari tanggal mulai";
                                                                                        }
                                                                                        return true;
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </td>
                                                                <td className="text-center">
                                                                    <Button
                                                                        className="btn btn-danger btn-sm" 
                                                                        id={"delete-" + val.id}
                                                                        onClick={() => {
                                                                            this.removeTableData(val.id)
                                                                        }}
                                                                        style={{
                                                                            padding: '2px 5px'
                                                                        }}>
                                                                        <i className="uil-trash-alt"></i>
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Col>
                                    <Col md="12">
                                        <div className="float-end">
                                            {/* <Button color="secondary" type="submit" onClick={() => this.setState({ isDraft: 1 })}>Simpan Draft</Button> */}
                                            {'  '}
                                            <Button color="success" type="submit" onClick={
                                                () => {this.setState({ isDraft: 0 })
                                                        // alert('aaaaaaaaa')
                                                        // this.checkplt()
                                                    }       
                                                }>Simpan</Button>
                                        </div>
                                    </Col>
                                </Row>

                            </AvForm>
                        </CardBody>    
                    </Card>    
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedMsg}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/petajabatan.html`} />
                : null }
            </Fragment>
        )
    }
}

export default CreateView